import { ComponentType, CSSProperties, ReactNode, useState } from 'react';
import * as S from './styles';
import { IconProps } from '@/types/icon';
import { useTheme } from 'styled-components';
import { IconeSeta } from '@/components/atoms/Icones/IconeSeta';

export type AccordionItemProps = {
  $size: 1 | 2 | 3 | 4;
  $variant: 'solid' | 'ghost';
  $disabled: 'off' | 'on';
  $IconStart?: ComponentType<IconProps>;
  $title: string;
  $conteudo: ReactNode;
  $style?: CSSProperties;
  $styleConteudo?: CSSProperties;
  $funcaoCallbackDuranteAberturaAccordion?: () => void;
};

export default function AccordionItem(props: AccordionItemProps) {
  const {
    $IconStart,
    $size,
    $conteudo,
    $title,
    $style = undefined,
    $styleConteudo = undefined,
    $funcaoCallbackDuranteAberturaAccordion,
  } = props;
  const theme = useTheme();
  const [estaAberto, setEstaAberto] = useState<boolean>(false);

  function lidarAberturaAccordion() {
    setEstaAberto((estadoAnterior) => !estadoAnterior);
    if ($funcaoCallbackDuranteAberturaAccordion)
      $funcaoCallbackDuranteAberturaAccordion();
  }

  return (
    <S.Container $size={$size} style={$style}>
      <S.Header $size={$size} onClick={lidarAberturaAccordion}>
        {$IconStart ? (
          <$IconStart
            color={theme.tokens.colors.text}
            size={theme.typography.font.size[6]}
          />
        ) : null}
        <S.Titulo>{$title}</S.Titulo>
        <S.IconContainer $estaAberto={estaAberto}>
          <IconeSeta
            direcao="baixo"
            color={theme.tokens.colors.text}
            size={theme.typography.font.size[6]}
          />
        </S.IconContainer>
      </S.Header>
      <S.Conteudo style={$styleConteudo} $estaAberto={estaAberto}>
        {$conteudo}
      </S.Conteudo>
    </S.Container>
  );
}
